<template>
    <!-- 内勤账号 -->
    <div class="main-container">
        <div class="content">
            <div class="search-box">
                <div class="input-item">
                    <span class="label">所属机构</span>
                    <selectTree v-model="searchObj.buzOrganId" :multiple="false" type="4"></selectTree>
                </div>

                <div class="input-item">
                    <span class="label">手机号</span>
                    <Input v-model="searchObj.mobile2" placeholder="请输入" clearable />
                </div>

                <div class="input-item">
                    <span class="label">账号</span>
                    <Input v-model="searchObj.account" placeholder="请输入" clearable />
                </div>

                <div class="input-item">
                    <span class="label">内勤人员</span>
                    <Input v-model="searchObj.indoorStaffName" placeholder="请输入" clearable />
                </div>

                <div class="input-item">
                    <span class="label">用户名</span>
                    <Input v-model="searchObj.userName" placeholder="请输入" clearable />
                </div>

                <div class="input-item">
                    <span class="label">状态</span>
                    <RadioGroup v-model="searchObj.enable">
                        <Radio label="">全部</Radio>
                        <Radio label="1">启用</Radio>
                        <Radio label="0">禁用</Radio>
                    </RadioGroup>
                </div>

                <div class="btn-item">
                    <Button type="primary" @click="getList()">搜索</Button>
                    <Button type="primary" ghost @click="reset">重置</Button>
                </div>
            </div>
            <div class="tools-box right">
                <Button type="warning" @click="$refs.addAccount.open()" v-show="$units.pointAction('org_10_2')">新增账号</Button>
                <!-- <Button type="primary" @click="$refs.importModal.open()" v-show="$units.pointAction('org_10_3')">批量导入</Button> -->
            </div>

            <div class="tableBox setTable">
                <loading :isShow="$root.$children[0].isShowLoading" />
                <div class="table-box">
                    <Table :columns="columns" :data="tableDate">

                      <template slot-scope="{ row }" slot="indoorStaffName">
                            <div class="user-box" v-if="row.indoorStaffName" @click="toIndoorStaff(row)">
                                <a class="counts">{{ row.indoorStaffName }}</a>
                            </div>
                        </template>

                        <template slot-scope="{ row }" slot="account">
                            <div class="user-box" v-if="row.account">
                                <i class="dian" :class="{ red: row.enable == 0 }"></i>
                                <span>{{ row.account }}</span>
                                <Tag color="success" style="margin-left:10px;" v-if="row.isLoginUser">
                                    登录用户
                                </Tag>
                            </div>
                        </template>

                        <template slot-scope="{ row }" slot="mobile3">
                            <span class="text" v-if="row.eyeShow">{{ row.mobile3 }}</span>
                            <span class="text" v-else>{{ row.mobile }}</span>
                            <span>
                                <i class="iconfont iconxianshi eye-icon" v-if="row.eyeShow" @click="openEye(row)"></i>
                                <i class="iconfont iconyincang eye-icon" v-else @click="openEye(row)"></i>
                            </span>
                        </template>

                        <template slot-scope="{ row }" slot="org">
                            <div class="user-box" v-if="row.buzOrganName" @click="toOrgManage(row, 1)">
                                <i class="dian" :class="{ red: row.orgStatus == 0 }"></i>
                                <a class="counts">{{ row.buzOrganName }}</a>
                            </div>
                        </template>

                        <template slot-scope="{ row }" slot="action">
                            <Dropdown
                                :transfer="true"
                                trigger="click"
                                transfer-class-name="salesman-manage-dropdown-menu"
                                @on-click="dropdownClick($event, row)"
                            >
                                <div class="more-btn">
                                    操作
                                    <Icon type="ios-arrow-down"></Icon>
                                </div>
                                <DropdownMenu slot="list">
                                    <DropdownItem name="1" v-if="$units.pointAction('org_10_4')&&row.enable == 1" :disabled="row.userId == userInfo.userid"
                                        >禁用</DropdownItem
                                    >
                                    <DropdownItem name="2" v-else :disabled="row.userId == userInfo.userid">启用</DropdownItem>
                                    <DropdownItem name="3" v-if="$units.pointAction('org_10_5')" :disabled="row.userId == userInfo.userid">变更角色</DropdownItem>
                                    <DropdownItem name="6" v-if="$units.pointAction('org_10_6')" :disabled="row.isLoginUser">数据权限</DropdownItem>
                                    <DropdownItem name="4" v-if="$units.pointAction('org_10_7')">角色权限</DropdownItem>
                                    <DropdownItem name="5" v-if="$units.pointAction('org_10_8')">重置密码</DropdownItem>
                                    <DropdownItem name="7">内勤人员</DropdownItem>
                                    <DropdownItem name="del" :disabled="row.isLoginUser">删除</DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                        </template>
                    </Table>

                    <div class="pageBox">
                        <Page
                            :total="total"
                            :current="searchObj.pageNo"
                            :page-size="searchObj.pageSize"
                            show-total
                            @on-change="pageChange"
                            style="text-align: center"
                        />
                    </div>
                </div>
            </div>
        </div>
        <!-- 新增账号 -->
        <add-account ref="addAccount" :initList="getList"></add-account>

        <!-- 禁用-启用 -->
        <disable-enable ref="disable" :initList="getList"></disable-enable>

        <!-- 重置密码 -->
        <password-form ref="passwordForm"></password-form>

        <!-- 变更角色 -->
        <change-role ref="changeRole" :initList="getList"></change-role>

        <!-- 数据权限 -->
        <data-authority ref="dataAuthority" :getList="getList"></data-authority>

        <!-- 批量导入 -->
        <import-modal ref="importModal" :getList="getList"></import-modal>

        <!-- 变更内勤人员 -->
        <changeHouseStaff ref="changeHouseStaff"></changeHouseStaff>
        <!-- 确认弹窗 -->
        <confirm-modal ref="confirmModal" />
    </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
import selectTree from '@/components/system/selectTree3';
import disableEnable from './components/disable_enable';
import passwordForm from './components/passwordForm';
import changeRole from './components/changeRole';
import addAccount from './components/addAccount';
import changeHouseStaff from './components/changeHouseStaff';
import dataAuthority from './components/dataAuthority';
import importModal from './components/importModal';
import confirmModal from '@/components/commons/confirmModal';
import { mapState } from 'vuex';

export default {
    components: {
        selectTree,
        disableEnable,
        passwordForm,
        changeRole,
        addAccount,
        changeHouseStaff,
        dataAuthority,
        confirmModal,
        importModal
    },
    mixins: [pageTool, common],
    computed: {
        ...mapState(['userInfo'])
    },
    data() {
        return {
            fileFormat:['xls','xlsx'],
            searchObj: {
                pageNo: 1,
                pageSize: 10
            },
            total: 0,
            columns: [
                {
                    title: '序号',
                    width: 80,
                    align: 'center',
                    type: 'index'
                },
                {
                    title: '内勤人员',
                    minWidth: 100,
                    align: 'center',
                    slot: 'indoorStaffName'
                },
                {
                    title: '登录账号',
                    minWidth: 100,
                    align: 'center',
                    slot: 'account'
                },
                {
                    title: '登录用户',
                    minWidth: 100,
                    align: 'center',
                    key: 'userName'
                },
                {
                    title: '手机号',
                    minWidth: 70,
                    align: 'center',
                    tooltip: true,
                    slot: 'mobile3'
                },
                {
                    title: '角色',
                    minWidth: 140,
                    align: 'center',
                    tooltip: true,
                    render(h, params) {
                        let roleName = params.row.roleName;
                        return h(
                            'Tooltip',
                            {
                                class:'flex-center',
                                props: { placement: 'bottom-start', transfer: true }
                            },
                            [
                                h(
                                    'span',
                                    {
                                        class: 'txt-ellipsis2'
                                    },
                                    roleName || '-'
                                ),
                                h('span', { slot: 'content'}, roleName || '-')
                            ]
                        );
                    }
                },
                {
                    title: '所属机构',
                    minWidth: 120,
                    align: 'center',
                    slot: 'org'
                },
                {
                    title: '操作',
                    slot: 'action',
                    align: 'center',
                    width: 120
                }
            ],
            tableDate: []
        };
    },

    created() {
        if(!this.$units.pointAction('org_10_4') && !this.$units.pointAction('org_10_5') && !this.$units.pointAction('org_10_6') && !this.$units.pointAction('org_10_7') && !this.$units.pointAction('org_10_8')){
            this.columns.splice(this.columns.length-1, 1);
        }
        this.getList();
    },

    methods: {
        toIndoorStaff(row){
          console.log(row);
          let query= {
            indoorStaffId: row.indoorStaffId,
          }
          this.$router.push({
            path: "/systemSet/houseStaffForm/" + row.userId,
            query: query
          })
        },
        //分页切换页码
        pageChange(pageNo) {
            this.getList(pageNo);
        },

        //列表
        getList(pageNo) {
            if(pageNo){
                this.searchObj.pageNo = pageNo 
            }else{
                this.searchObj.pageNo = 1
            }
            this.$root.$children[0].isShowLoading = true;
            this.$http({
                url: '/buz/usersExt/read/list',
                type: 'POST',
                data: this.searchObj,
                apiPermissionCode:'org_10_0'
            })
                .then(res => {
                    let pageNum = this.searchObj.pageNo;
                    if((!res.data||res.data.length==0)&&pageNum!=1) {
                        pageNum--;
                        this.getList(pageNum);
                        return;
                    }
                    this.total = res.total;
                    this.tableDate = res.data;
                    this.$root.$children[0].isShowLoading = false;
                })
                .catch((e) => {
                    console.log(e);
                    this.$root.$children[0].isShowLoading = false;
                });
        },

        // 重置
        reset() {
            this.searchObj = {
                pageNo: 1,
                pageSize: 10
            };
            this.getList();
        },

        // 组织架构
        toOrgManage(row, type) {
            // type 1:机构 、 2：团队
            this.$router.push({
                path: '/orgManage/index',
                query: {
                    organizationId: row.buzOrganId,
                    type
                }
            });
        },

        // 解密
        openEye(row) {
            if (!row.eyeShow) {
                this.descrypt(
                    {
                        query: row.id,
                        operationFunction: 9,
                        operationType: 2
                    },
                    row,
                    'mobile3',
                    'org_10_1'
                ).then(() => {
                    this.$set(row, 'eyeShow', true);
                });
            } else {
                this.$set(row, 'eyeShow', false);
            }
        },

        // 文件文件格式验证失败时的钩子，返回字段为 file, fileList
        handleFormatError(file) {
            if (!this.fileFormat || this.fileFormat.length == 0) {
                return true;
            }
            const format = file.name.split('\.')[1];
            if (!this.fileFormat.includes(format)) {
                this.$notice.msg('请上传' + this.fileFormat.join(',') + '格式的文件');
                return false;
            }
        },

        // 文件上传成功时的钩子，返回字段为 response, file, fileList
        handleUploadSuccess(res) {
            if(res.httpCode){
                this.$Message.success('上传成功');
                this.getList();
            }else{
                this.$Message.error(res.msg);
            }
        },

        // 编辑
        dropdownClick(e, row) {
            if (e == '1') {
                this.$refs.disable.open(row, 0);
            } else if (e == '2') {
                this.$refs.disable.open(row, 1);
            } else if (e == '3') {
                this.$refs.changeRole.open(row);
            } else if (e == '4') {
                this.$router.push({
                    path: '/systemSet/accountNumManage/roleAuthority',
                    query: {
                        id: row.roleId
                    }
                });
            } else if (e == '5') {
                this.$refs.passwordForm.open(row);
            } else if (e == '6') {
                this.$refs.dataAuthority.open(row);
            }else if(e == '7'){
              this.$refs.changeHouseStaff.open(row)
            }else if(e == 'del'){
              this.delRow(row)
            }
        },
        delRow(row) {
            this.$refs.confirmModal
                .open({
                    title: '提示',
                    content: '请确认是否删除？'
                })
                .then(() => {
                    this.$http({
                        url: "/buz/usersExt/delIndoorStaffAccount",
                        type: "DELETE",
                        query: {
                            id: row.id,
                        }
                    }).then(() => {
                        this.$notice.success('删除成功');
                        this.getList();
                    })
                });
        }
    }
};
</script>
<style lang="scss" scoped>
/deep/ .ivu-table-cell-slot .detail > div {
    margin-right: 10px;
    font-size: 13px;
}

/deep/ .ivu-modal-body {
    padding: 16px 30px;
}

/deep/ .formGroup {
    position: relative;

    &:after {
        position: absolute;
        bottom: -15px;
        width: 100%;
        height: 20px;
        content: '';
        filter: blur(5px);
        background: #fff;
    }

    padding: 0;

    .title {
        font-size: 16px;
        font-weight: bold;
        color: #3c464f;
    }
}

.pageBox {
    margin-top: 20px;
}

.content {
    .tableBox {
        padding-bottom: 25px;
        background-color: #fff;
        position: relative;
        z-index: 100;
    }

    .counts {
        text-decoration: underline;
    }
    /deep/ .user-box {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 13px;
        color: #236dff;
        &.text {
            color: #515c6f;
        }
        .user-name {
            cursor: pointer;
            &.dashed {
                border-bottom: 1px dashed #236dff;
            }
            &.line {
                border-bottom: 1px solid #236dff;
            }
        }
        span {
            color: #3c464f;
        }
        .dian {
            display: block;
            width: 5px;
            height: 5px;
            background: #35bf3f;
            border-radius: 50%;
            margin-right: 4px;
            &.red {
                background: #e3461f;
            }
        }
        i {
            color: #bababa;
            font-size: 13px;
        }
        .iconduichang {
            color: #ed8b43;
            margin-left: 4px;
        }
    }

    .more-btn {
        width: 70px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 15px;
        background: #f4f7ff;
        border: 2px;
        color: #236dff;
        font-size: 13px;
    }
}
</style>
